import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
declare var $: any;
@Component({
  selector: 'app-edit-animal-death',
  templateUrl: './edit-animal-death.component.html',
  styleUrls: ['./edit-animal-death.component.css']
})
export class EditAnimalDeathComponent implements OnInit {
  getdeatheditApi:any;
  putdeatheditApi:any;
  EditSamplesDeath:any;
  addUrl:any;
  getlistApi:any;
  getDiseaseListData:any;
  loginresponse:any;
  cby_mby:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService:CommonService) { }

  async ngOnInit(){
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby=this.loginresponse.user_id;
    let DeathId = sessionStorage.getItem('deathId');
    this.getdeatheditApi= "/animal_management/death/"+ DeathId;
    this.putdeatheditApi= "/animal_management/death/"+ DeathId;
    (await this.commonService.getApi(this.getdeatheditApi)). subscribe(
    (res:any) => {
         var date=res.data.tnam_dth_date_of_death;
         var testdate = date.split('T');
        $("#deathdate").val(testdate[0])       
         $("#dathcause").val(res.data.tnam_dth_cause_of_death)
        })
  }
  async AnimalDeath(){
    var farmid=sessionStorage.getItem('farmid');
    var Animalid=sessionStorage.getItem('animalid');
    var speciesid=sessionStorage.getItem('speciesid');
    var breedid=sessionStorage.getItem('breedid');
    var ageid=sessionStorage.getItem('ageid');
    this.EditSamplesDeath = {
      "species_id":speciesid,
      "breed_id":breedid,
      "farm_id":farmid,
      "animal_code":Animalid,
      "age_group":ageid,
      "cause_of_death":$("#dathcause").val(),
      "date_of_death":$("#deathdate").val(),
      "cby":this.cby_mby,
      "mby": this.cby_mby,
      "status": 1,
      "is_active": 1
  };
    (await this.commonService.putApi(this.putdeatheditApi,this.EditSamplesDeath)).subscribe(
      data => {
          alert("Data edited successfully");
      });
      setTimeout(
        () : void => {
       
     this.router.navigate([this.returnUrl,{ fragment: 'Disease' }]);

        },
        500
      );
//}
  }

  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }

}
